// Components
import Icon from '@/components/base/Icon';
import Select from '@/components/base/Select';
import SelectFilter from '@/components/base/SelectFilter';
import ActionTag from '@/components/base/Tag/ActionTag';

const ButtonSelectItems = ({
    placeholder,
    error,
    disabled,
    selected,
    style = 'grayBackground'
}) => {
    return (
        <Select.Button selected={selected} disabled={disabled} error={error} baseStyle={style}>
            <div className="flex items-center space-x-3">
                <span className="block truncate text-icoGray-400 dark:text-icoDarkMode-wolf">
                    {placeholder}
                </span>
            </div>
        </Select.Button>
    );
};
const SelectAlbumTags = ({
    idInput,
    options = [],
    placeholder,
    selectedItems = [],
    removeItem = () => {
        /** */
    },
    addItem = () => {
        /** */
    },
    onSearch,
    activeActionTags = true,
    buttonStyle = 'grayBackground'
}) => {
    return (
        <>
            <SelectFilter
                idInput={idInput}
                button={<ButtonSelectItems style={buttonStyle} placeholder={placeholder} />}
                selected={null}
                setSelected={addItem}
                options={options}
                onSearch={onSearch}
                error={false}
                required
                noBorder
            />
            {activeActionTags && selectedItems?.length > 0 ? (
                <ul className="mt-3 flex flex-wrap gap-2">
                    {selectedItems.map((item, index) => {
                        return (
                            <li key={index}>
                                <ActionTag data-testid="input-action-tag">
                                    <Icon
                                        icon={item?.type === 'hashtag' ? 'hashtag' : 'labels'}
                                        className="p-1 align-bottom"
                                    />
                                    <span className="mr-1">{item.value ?? item.label}</span>
                                    <button
                                        id={item.id}
                                        aria-label="input-action-tag-delete"
                                        className="leading-none"
                                        onClick={() => removeItem(item)}>
                                        <Icon icon="close" className="align-bottom" />
                                    </button>
                                </ActionTag>
                            </li>
                        );
                    })}
                </ul>
            ) : null}
        </>
    );
};

export default SelectAlbumTags;
